module.exports = __webpack_public_path__ + "static/media/hand_desktop.6ae874b5.png";